import PasswordInputComponent from "./password-input.js";
import PasswordInputFeedback from "./password-input-feedback.js";
const PasswordInput = PasswordInputComponent;
PasswordInput.Feedback = PasswordInputFeedback;
export default PasswordInput;
